(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-accordian"] && !Shopify.designMode) return;
  try {
    /**
   * pdToggle — accordion open/close
   * Closes all others when one opens (accordion behaviour).
   */
  } catch(e) { console.error(e); }
})();

})();
